import { createSelector } from 'reselect';

const selectReferrerPatientView = (state) => state.get('referrerPatientView');

export const makeSelectProfile = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('profile')?.toJS() : null
	);

export const makeSelectProfileLoading = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('profileLoading') : false
	);

export const makeSelectCalendarEvents = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('calendarEvents')?.toJS() : []
	);

export const makeSelectCalendarLoading = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('calendarLoading') : false
	);

export const makeSelectGroups = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('groups')?.toJS() : []
	);

export const makeSelectGroupsLoading = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('groupsLoading') : false
	);

export const makeSelectOq = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('oq')?.toJS() : null
	);

export const makeSelectOqLoading = () =>
	createSelector(selectReferrerPatientView, (sub) =>
		sub ? sub.get('oqLoading') : false
	);
